import { laravelAxios } from '../../../../config/axios/laravelAxios';

async function getOerator(contact) {
  const getOperator = await laravelAxios.get(
    'crm/getOperator/' + contact
  );
  return getOperator;
}
export default getOerator;
